<template>
	<b-modal ref="mdlIntestazione" :title="description.tipoSoggetto" size="xl" modal-class="sa-modal-static-scroll"
		style="height: 100%; max-height: calc(100vh - 3.5rem)" centered @show="onShowRicercaDatiSoggetto"
		@ok="onOkModificaDatiCliente" :no-close-on-backdrop="true" :no-close-on-esc="true">
		<b-form>
			<div class="sa-form-section sa-search-box">
				<b-row style="row-gap: 8px">
					<b-col cols="12" xs="12" sm="12" md="3" lg="6" xl="6">
						<b-row class="p-2" style="margin: 5px">
							<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
								<h5 class="sa-search-h5 sa-text-left">
									{{ this.description.tipoSoggetto }}
									<template v-if="isDatiClienteFornitoreComplete">✅</template>
									<template v-else>⚠️</template>
								</h5>
								<hr />
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
								<div class="sa-search-search-wrapper">
									<input class="sa-search-box-input" v-model="localData.soggettoCognomeRagione"
										placeholder="Cognome, Nome o Ragione Sociale" />
									<button @click="onClickRicercaDatiSoggetto" class="sa-prescrizione-btn-search"
										title="Cerca">
										<i class="fas fa-search"></i>
									</button>
								</div>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
								<input class="sa-search-box-input" v-model="localData.soggettoCodiceFiscale"
									placeholder="Codice Fiscale" />
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
								<input class="sa-search-box-input" v-model="localData.soggettoPartitaIva"
									placeholder="Partita I.V.A." />
							</b-col>

							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
								<b-form-select id="inline-form-custom-select-pref" v-model="localData.soggettoProvincia"
									class="sa-search-input" :options="provinceOptions" value-field="sigla"
									text-field="provincia" :value="null" @input="loadComuni($event)">
									<template #first>
										<b-form-select-option :value="null" disabled>- Seleziona Provincia
											-</b-form-select-option>
									</template>
								</b-form-select>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
								<b-form-select id="inline-form-custom-select-pref"
									v-model="localData.soggettoLocalitaCodiceIstat" class="sa-search-input"
									:options="comuniOptions" value-field="codiceIstat" text-field="comune"
									@input="setCap($event)">
									<template #first>
										<b-form-select-option :value="null" disabled>- Seleziona Comune
											-</b-form-select-option>
									</template>
								</b-form-select>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
								<input class="sa-search-box-input" v-model="localData.soggettoCap"
									placeholder="C.A.P." />
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
								<input class="sa-search-box-input" v-model="localData.soggettoIndirizzo"
									placeholder="Indirizzo" />
							</b-col>

							<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-2">
								<h5 class="sa-search-h5 sa-text-left">
									Metodo Pagamento e {{ this.description.testoBottom }}
									<template v-if="isMagazzinoScaricoMetodoPagamentoComplete">✅</template>
									<template v-else>⚠️</template>
								</h5>
								<hr />
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
								<b-form-select id="inline-form-custom-select-pref" v-model="localData.metodoPagamentoId"
									class="sa-search-input" :options="contabilitaMetodiPagamentoOptions"
									value-field="id" text-field="descrizioneMetodoPagamento"
									@change="setInfoMetodoPagamento()">
									<template #first>
										<b-form-select-option :value="null" disabled>- Metodo di Pagamento
											-</b-form-select-option>
									</template>
								</b-form-select>
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
								<b-form-select id="inline-form-custom-select-pref" v-model="localData.magazzinoId"
									class="sa-search-input" :value="null" @change="onChangeMagazzino">
									<template #first>
										<b-form-select-option :value="null" disabled>- Seleziona {{
											description.testoBottom }}
											-</b-form-select-option>
									</template>
									<template>
										<b-form-select-option v-for="mag of magazziniFisici" :key="mag.id"
											:value="mag.id"> {{ mag.descrizioneMagazzino }} ({{ mag.codiceMagazzino }})
											- {{ mag.tipo }} </b-form-select-option>
									</template>
								</b-form-select>
							</b-col>
						</b-row>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
						<b-row class="p-2" style="margin: 5px">
							<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
								<h5 class="sa-search-h5 sa-text-left">
									<span>{{ description.testoRight }}
										<template v-if="isDatiDestinazioneComplete">✅</template>
										<template v-else>⚠️</template>
									</span>
								</h5>
								<hr />
							</b-col>
							<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
								<b-form-select id="inline-form-custom-select-pref" v-model="selezioneDestinazione"
									class="sa-search-input" :value="null"
									:disabled="!isDatiClienteFornitoreComplete && !isMagazzinoScaricoMetodoPagamentoComplete"
									@change="onChangeDestinazione">
									<template #first>
										<b-form-select-option :value="null" disabled> - Seleziona {{
											description.testoRight }} -
										</b-form-select-option>
									</template>
									<template>
										<b-form-select-option value="IDEM"> IDEM </b-form-select-option>
										<b-form-select-option value="ALTRO"> ALTRO </b-form-select-option>
										<b-form-select-option
											v-for="indirizzoDestinazione of contabilitaSoggettoAltriIndirizziOptions"
											:key="indirizzoDestinazione.id" :value="indirizzoDestinazione.id">
											{{ indirizzoDestinazione.altriIndirizziDescrizione }} - {{
												indirizzoDestinazione.altriIndirizziIndirizzo }} ({{
												indirizzoDestinazione.altriIndirizziProvincia }})
										</b-form-select-option>
									</template>
								</b-form-select>
							</b-col>
							<template>
								<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
									<input class="sa-search-box-input" v-model="localData.destinazioneMerceDescrizione"
										placeholder="Descrizione" :disabled="selezioneDestinazione != 'ALTRO'" />
								</b-col>

								<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
									<b-form-select v-model="localData.destinazioneMerceProvincia"
										class="sa-search-input" :options="provinceOptions" value-field="sigla"
										text-field="provincia" :value="null" @input="loadComuni($event)"
										:disabled="selezioneDestinazione != 'ALTRO'">
										<template #first>
											<b-form-select-option :value="null">- Seleziona Provincia
												-</b-form-select-option>
										</template>
									</b-form-select>
								</b-col>
								<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
									<b-form-select id="inline-form-custom-select-pref"
										v-model="localData.destinazioneMerceLocalita" class="sa-search-input"
										:options="comuniOptions" value-field="codiceIstat" text-field="comune"
										@input="setCap($event)" :disabled="selezioneDestinazione != 'ALTRO'">
										<template #first>
											<b-form-select-option :value="null" disabled>- Seleziona Comune
												-</b-form-select-option>
										</template>
									</b-form-select>
								</b-col>
								<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
									<input class="sa-search-box-input" v-model="localData.destinazioneMerceCap"
										placeholder="C.A.P." :disabled="selezioneDestinazione != 'ALTRO'" />
								</b-col>
								<b-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
									<input class="sa-search-box-input" v-model="localData.destinazioneMerceIndirizzo"
										placeholder="Indirizzo" :disabled="selezioneDestinazione != 'ALTRO'" />
								</b-col>
							</template>
						</b-row>
					</b-col>
				</b-row>
			</div>
			<div class="sa-form-section" style="margin-top: 10px"></div>
		</b-form>
		<br />
		<h5 class="sa-search-h5 sa-text-left">{{ description.archivio }}</h5>
		<b-row>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<div class="b-table-sticky-header">
					<!-- <b-table id="tabellaIntestatario" hover :items=tabellaDatiSoggetto" :fields="clientiFields" selectable select-mode="single" head-variant="light" @row-selected="onRowSelectedCliente" class="sa-b-table"> -->
					<b-table sticky-header id="tabellaIntestatario" ref="table" selectable
						@row-selected="onRowSelectedCliente" stacked="xl" striped hover select-mode="single"
						:items="contabilitaSoggetti" :fields="clientiFields" sort-icon-left head-variant="light"
						class="sa-b-table">
						<template #cell(index)="data">
							{{ data.index + 1 }}
						</template>
					</b-table>
				</div>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
import axios from "axios";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";
import SoggettiMixin from "../mixins/SoggettiMixin";

// import DatePicker from "vue2-datepicker";
export default {
	mixins: [ContabilitaMixin, StruttureMixin, UtilityMixin, MagazzinoMixins, SoggettiMixin],
	//   components: { DatePicker },
	props: {
		soggettiCollegati: { type: String },
		operazioneMagazzino: { type: Number },
	},
	data() {
		return {
			title: "",
			selezioneDestinazione: null,
			pathResource: "/contabilitadocumentotipo",
			comuniOptions: [],
			provinceOptions: [],
			disabledSelezioneDestinazioneMerci: false,
			altriIndirizziOptions: [],
			tabellaDatiSoggetto: [],
			causaleDocumentoJsonData: null,
			tipoDocumentoJsonData: null,
			clientiFields: [
				{
					label: "N.",
					key: "index",
					sortable: false,
					thStyle: "width: 2em",
				},
				{
					label: "Cognome Nome/Ragione Sociale",
					key: "ragioneSoggetto",
					sortable: true,
				},
				{
					label: "Codice Soggetto",
					key: "codiceSoggetto",
					sortable: true,
				},
				{
					label: "Codice Fiscale",
					key: "identificativoSoggetto",
					sortable: true,
				},
				{
					label: "Partita I.V.A",
					key: "pivaSoggetto",
					sortable: true,
				},
				{
					label: "Note Documento",
					key: "noteDocumento",
					sortable: true,
				},
			],
			options: [{ text: "Option1", value: "OP1" }],
			datiClienteFornitoreValidator: { esito: false, msg: null },
			datiMetodoPagamentoMagazzinoValidator: { esito: false, msg: null },
			datiDestinazioneValidator: { esito: false, msg: null },
			dati: { esito: false, msg: null },
			description: {
				datiTipoSoggetto: "",
				testoRight: "",
				testoBottom: "",
				archivio: ""
			},
			localData: {
				soggettoNome: null,
				soggettoCognomeRagione: null,
				soggettoCap: null,
				soggettoCodiceFiscale: null,
				soggettoId: null,
				soggettoPartitaIva: null,
				soggettoProvincia: null,
				soggettoLocalitaCodiceIstat: null,
				soggettoLocalita: null,
				soggettoIndirizzo: null,
				magazzinoCap: null,
				magazzinoCodice: null,
				magazzinoDescrizione: null,
				magazzinoId: null,
				magazzinoIndirizzo: null,
				magazzinoLocalita: null,
				magazzinoLocalitaCodiceIstat: null,
				magazzinoProvincia: null,
				metodoPagamentoDescrizione: null,
				metodoPagamentoId: null,
				destinazioneMerceDescrizione: null,
				destinazioneMerceIndirizzo: null,
				destinazioneMerceCap: null,
				destinazioneMerceLocalita: null,
				destinazioneMerceProvincia: null
			},
		};
	},
	computed: {
		isDatiClienteFornitoreComplete() {
			return this.datiClienteFornitoreValidator.esito;
		},
		isDatiDestinazioneComplete() {
			return this.datiDestinazioneValidator.esito;
		},
		isMagazzinoScaricoMetodoPagamentoComplete() {
			return this.datiMetodoPagamentoMagazzinoValidator.esito;
		},

		isDocumentoEmesso() {
			if (!this.tipoDocumentoJsonData) {
				return false;
			} else if (this.tipoDocumentoJsonData.tipoDocumento === "EMESSO") {
				return true;
			}
			return false;
		},
		indirizzoMagazzino() {
			const indirizzo = this.localData.magazzinoIndirizzo || "";
			const cap = this.localData.magazzinoCap || "";
			const provincia = this.localData.magazzinoProvincia || "";
			const localita = this.localData.magazzinoLocalita || "";
			let returnValue = [];
			if (indirizzo) {
				returnValue.push(indirizzo);
			}
			if (cap) {
				returnValue.push(cap);
			}
			if (provincia) {
				returnValue.push(`(${provincia})`);
			}
			if (localita) {
				returnValue.push(localita);
			}
			return returnValue.join(", ");
		},
	},
	watch: {
		// "localData.soggettoProvincia"() {
		// 	if (this.localData.id == "-1") {
		// 		this.localData.soggettoLocalitaCodiceIstat = null;
		// 		this.localData.soggettoLocalita = null;
		// 		this.localData.soggettoCap = null;
		// 	}
		// },
		localData: {
			handler() {
				this.validazioneDatiFornitoreCliente();
				this.validazioneDestinazione();
				this.validazioneMetodoPagamentoMagazzino();
			},
			deep: true,
		},
	},
	mounted() {
		this.id = this.$route.params.id;
		this.loadProvince();
		this.loadMetodiPagamento();
		this.isRicercaSoggetto = false;
	},
	methods: {
		init(jsonData, causaleDocumentoJsonData, tipoDocumentoJsonData) {
			this.causaleDocumentoJsonData = causaleDocumentoJsonData;
			this.tipoDocumentoJsonData = tipoDocumentoJsonData;
			this.localData = { ...jsonData };
			this.loadComuni(jsonData.soggettoProvincia);
			this.setPresidio();
			this.loadMagazzini();
			this.contabilitaSoggettoAltriIndirizziLoadData();
			this.show();
		},
		onClickCloseRicercaSoggetto() {
			this.isRicercaSoggetto = false;
			this.onResetDatiCliente();
		},
		setInfoMetodoPagamento() {
			if (this.localData.metodoPagamentoId) {
				let result = this.contabilitaMetodiPagamentoOptions.filter((e) => e.id == this.localData.metodoPagamentoId);
				if (result[0]) {
					let metodoPagamento = result[0];
					this.localData.metodoPagamentoDescrizione = metodoPagamento.descrizioneMetodoPagamento;
				}
			}
		},
		loadMetodiPagamento() {
			this.contabilitaMetodiPagamentoLoadData();
		},
		setDescrizioni() {
			let tipoSoggetto = "";
			let testoBottom = "";
			let testoRight = "";
			let archivio = "";
			if (this.tipoDocumentoJsonData == null) {
				tipoSoggetto = "-";
				testoBottom = "-";
				testoRight = "-";
				archivio = "-"
			} else {
				switch (this.tipoDocumentoJsonData.tipoDocumento) {
					case "EMESSO":
						tipoSoggetto = "Cliente";
						testoBottom = "Magazzino Scarico Merce";
						testoRight = "Destinazione Merce"
						archivio = "Archivio Clienti"
						break;
					case "INTERNO":
						break;
					case "RICEVUTO":
						tipoSoggetto = "Fornitore";
						testoBottom = "Magazzino Carico Merce";
						testoRight = "Partenza Merce"
						archivio = "Archivio Fornitori"
						break;
					default:
						break;
				}
			}

			this.description.tipoSoggetto = `Dati ${tipoSoggetto}`;
			this.description.testoBottom = `${testoBottom}`;
			this.description.testoRight = `${testoRight}`;
			this.description.archivio = `${archivio}`;
		},
		onShowRicercaDatiSoggetto() {
			this.setDescrizioni();
		},
		onChangeMagazzino(param) {
			console.log(param);
			if (param) {
				if (param === "IDEM") {
					this.localData.magazzinoDescrizione = "IDEM";
				} else {
					let result = this.magazzinoMagazziniOptions.filter((e) => e.id == param);
					let magazzino = result[0];
					this.localData.magazzinoCap = magazzino.capMagazzino;
					this.localData.magazzinoCodice = magazzino.codiceMagazzino;
					this.localData.magazzinoDescrizione = magazzino.descrizioneMagazzino;
					this.localData.magazzinoIndirizzo = magazzino.indirizzoMagazzino;
					this.localData.magazzinoLocalitaCodiceIstat = magazzino.localitaMagazzino;
					this.localData.magazzinoProvincia = magazzino.provinciaMagazzino;
				}
			}
		},
		onChangeDestinazione(destinazione) {


			if (destinazione === "IDEM") {
				this.localData.destinazioneMerceDescrizione = "IDEM";
				this.localData.destinazioneMerceIndirizzo = this.localData.soggettoIndirizzo;
				this.localData.destinazioneMerceCap = this.localData.soggettoCap;
				this.localData.destinazioneMerceLocalita = this.localData.soggettoLocalitaCodiceIstat;
				this.localData.destinazioneMerceProvincia = this.localData.soggettoProvincia;
			} else if (destinazione === "ALTRO") {
				this.localData.destinazioneMerceDescrizione = null;
				this.localData.destinazioneMerceIndirizzo = null;
				this.localData.destinazioneMerceCap = null;
				this.localData.destinazioneMerceLocalita = null;
				this.localData.destinazioneMerceProvincia = null;
			} else {
				let result = this.contabilitaSoggettoAltriIndirizziOptions.filter((e) => e.id == destinazione);
				let destination = result[0];
				this.localData.destinazioneMerceDescrizione = destination.altriIndirizziDescrizione;
				this.localData.destinazioneMerceIndirizzo = destination.altriIndirizziIndirizzo;
				this.localData.destinazioneMerceCap = destination.altriIndirizziCap;
				this.localData.destinazioneMerceLocalita = destination.altriIndirizziLocalita;
				this.localData.destinazioneMerceProvincia = destination.altriIndirizziProvincia;
			}
		},

		loadMagazzini() {
			this.magazzinoMagazziniLoadData({ codiceStruttura: this.presidio.codiceStruttura });
		},
		loadProvince() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + "/province";
			axios.get(link).then((response) => {
				me.provinceOptions = response.data.data;
			});
		},
		loadComuni(sigla) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + "/comuni/provincia/" + sigla;
			axios.get(link).then((response) => {
				me.comuniOptions = response.data.data;
				if (me.localData.soggettoCap === null) {
					me.setCap(me.localData.soggettoLocalitaCodiceIstat);
				}
			});
		},
		onClickRicercaDatiSoggetto() {
			this.resetDestinazioneMerci();
			this.filtroContabilitaSoggetti = { ragioneSoggetto: this.descrizioneRagioneSoggetto, codiceTipoSoggetto: this.causaleDocumentoJsonData.soggettiCollegati };
			this.contabilitaSoggettiLoadData();
		},
		resetDestinazioneMerci() {
			this.localData.magazzinoId = null;
			this.selezioneDestinazione = null;
			this.localData.destinazioneMerceDescrizione = null;
			this.localData.destinazioneMerceIndirizzo = null;
			this.localData.destinazioneMerceCap = null;
			this.localData.destinazioneMerceLocalita = null;
			this.localData.destinazioneMerceProvincia = null;
		},

		onRowSelectedCliente(item) {
			let me = this;
			if (item.length > 0) {
				this.resetDestinazioneMerci();
				let soggetto = item[0];
				me.localData.soggettoCognomeRagione = soggetto.ragioneSoggetto;
				me.localData.soggettoCap = soggetto.capSoggetto;
				me.localData.soggettoCodiceFiscale = soggetto.identificativoSoggetto;
				me.localData.soggettoId = soggetto.id;
				me.localData.soggettoPartitaIva = soggetto.pivaSoggetto;
				me.localData.soggettoProvincia = soggetto.provinciaSoggetto;
				me.localData.soggettoLocalitaCodiceIstat = soggetto.localitaSoggetto;
				me.localData.soggettoIndirizzo = soggetto.indirizzoSoggetto;
				if (soggetto.codiceMetodoPagamento != null && soggetto.codiceMetodoPagamento != "") {
					let metodoPagamento = this.contabilitaMetodiPagamentoOptions.filter((e) => e.codiceMetodoPagamento == soggetto.codiceMetodoPagamento);
					if (metodoPagamento[0]) {
						let metodo = metodoPagamento[0];
						me.localData.metodoPagamentoId = metodo.id;
						this.localData.metodoPagamentoDescrizione = metodo.descrizioneMetodoPagamento;
					}
				}
			}
		},
		setCap(value) {
			let me = this;
			me.comuniOptions.forEach((comune) => {
				if (comune.codiceIstat === value) {
					me.localData.soggettoCap = comune.cap;
					me.localData.soggettoLocalita = comune.comune;
				}
			});
		},

		onResetDatiCliente() {
			this.localData = {
				soggettoNome: null,
				soggettoCognomeRagione: null,
				soggettoCap: null,
				soggettoCodiceFiscale: null,
				soggettoId: null,
				soggettoPartitaIva: null,
				soggettoProvincia: null,
				soggettoLocalitaCodiceIstat: null,
				soggettoLocalita: null,
				soggettoIndirizzo: null,
				magazzinoCap: null,
				magazzinoCodice: null,
				magazzinoDescrizione: null,
				magazzinoId: null,
				magazzinoIndirizzo: null,
				magazzinoLocalita: null,
				magazzinoLocalitaCodiceIstat: null,
				magazzinoProvincia: null,
				metodoPagamentoDescrizione: null,
				metodoPagamentoId: null,
				destinazioneMerceDescrizione: null,
				destinazioneMerceIndirizzo: null,
				destinazioneMerceCap: null,
				destinazioneMerceLocalita: null,
				destinazioneMerceProvincia: null,

			};
		},
		closeModal() {
			let me = this;
			me.$refs.mdlIntestazione.hide();
		},
		show() {
			let me = this;
			me.$refs.mdlIntestazione.show();
		},
		onOkModificaDatiCliente(event) {
			let me = this;
			if (!this.datiClienteFornitoreValidator.esito || !this.datiMetodoPagamentoMagazzinoValidator.esito
				|| !this.datiDestinazioneValidator.esito) {
				let obj = {
					msg: this.datiClienteFornitoreValidator.msg + " " + this.datiMetodoPagamentoMagazzinoValidator.msg + " " + this.datiDestinazioneValidator.msg
				}
				this.generaBtoast(obj);
				event.preventDefault();
				return;
			}
			me.$emit("update", me.localData);
			me.$refs.mdlIntestazione.hide();
		},
		validazioneDatiFornitoreCliente() {
			let esito = true;
			let msg = "";
			if (this.localData.soggettoCognomeRagione == null || this.localData.soggettoCognomeRagione.trim() == "") {
				msg += "Cognome/Ragione Sociale non valida! #";
				esito = false;
			}

			if (this.localData.soggettoCodiceFiscale == null || this.localData.soggettoCodiceFiscale.trim() == "") {
				msg += "CodiceFiscale non valido! #";
				esito = false;
			}
			if (this.localData.soggettoProvincia == null || this.localData.soggettoProvincia.trim() == "") {
				msg += "Provincia non valido! #";
				esito = false;
			}
			if (this.localData.soggettoLocalitaCodiceIstat == null || this.localData.soggettoLocalitaCodiceIstat.trim() == "") {
				msg += "Localita/Comune non valido! #";
				esito = false;
			}
			if (this.localData.soggettoIndirizzo == null || this.localData.soggettoIndirizzo.trim() == "") {
				msg += "Indirizzo non valido! #";
				esito = false;
			}
			if (this.localData.soggettoCap == null || this.localData.soggettoCap.trim() == "") {
				msg += "Cap non valido! #";
				esito = false;
			}
			this.datiClienteFornitoreValidator = { esito: esito, msg: msg };
		},
		validazioneMetodoPagamentoMagazzino() {
			let esito = true;
			let msg = "";
			if (this.localData.metodoPagamentoId == null || this.localData.metodoPagamentoId.trim() == "") {
				msg += "Medoto Pagamento Obbligatorio! #";
				esito = false;
			}
			if (this.localData.magazzinoId == null || this.localData.magazzinoId.trim() == "") {
				msg += "Magazzino Scarico Obbligatorio! #";
				esito = false;
			}

			this.datiMetodoPagamentoMagazzinoValidator = { esito: esito, msg: msg };
		},
		validazioneDestinazione() {
			let esito = true;
			let msg = "";

			if (!this.selezioneDestinazione) {
				msg += "Selezionare Destinazione! #";
				esito = false;
			}

			switch (this.selezioneDestinazione) {
				case "ALTRO":
					if (this.localData.destinazioneMerceDescrizione == null || this.localData.destinazioneMerceDescrizione.trim() == "") {
						msg += "Descrizione Destinazione non valido! #";
						esito = false;
					}
					if (this.localData.destinazioneMerceIndirizzo == null || this.localData.destinazioneMerceIndirizzo.trim() == "") {
						msg += "Indirizzo Destinazione non valido! #";
						esito = false;
					}
					if (this.localData.destinazioneMerceCap == null || this.localData.destinazioneMerceCap.trim() == "") {
						msg += "Cap Destinazione non valido! #";
						esito = false;
					}
					if (this.localData.destinazioneMerceLocalita == null || this.localData.destinazioneMerceLocalita.trim() == "") {
						msg += "Localita/Comune Destinazione non valido! #";
						esito = false;
					}
					if (this.localData.destinazioneMerceProvincia == null || this.localData.destinazioneMerceProvincia.trim() == "") {
						msg += "Provincia Destinazione non valido! #";
						esito = false;
					}
					break;
				case "IDEM":
					break;
				default:
					break;
			}

			this.datiDestinazioneValidator = { esito: esito, msg: msg };
		},
		setPresidio() {
			let tmpPresidio = window.localStorage.getItem("presidio");
			if (tmpPresidio) {
				this.presidio = JSON.parse(tmpPresidio);
				this.strutturaLoadDataByCodice(this.presidio.codiceStruttura);
			}
		},
		generaBtoast(validation) {
			let message = validation.msg.split("#");
			const h = this.$createElement;
			const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
			message.forEach((element) => {
				if (element.trim() != "") {
					vNodesMsg.children.push({ tag: "li", text: element });
				}
			});
			this.$bvToast.toast([vNodesMsg], {
				title: "Attenzione!",
				autoHideDelay: 5000,
				variant: "danger",
			});
		},
	},
};
</script>
<style scoped>
.sa-card-section {
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	height: 100%;
	overflow: hidden;
	border: 1px solid #e0e0e0;
}

.sa-card-header {
	padding: 15px 20px;
	background-color: #f8f9fa;
	border-bottom: 1px solid #eee;
}

.border-top-green {
	border-top: 4px solid #28a745 !important;
}

.border-top-orange {
	border-top: 4px solid orange !important;
}
</style>
